import { render, staticRenderFns } from "./phoneLogin.vue?vue&type=template&id=33c9adb0&scoped=true"
import script from "./phoneLogin.vue?vue&type=script&lang=js"
export * from "./phoneLogin.vue?vue&type=script&lang=js"
import style0 from "./phoneLogin.vue?vue&type=style&index=0&id=33c9adb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c9adb0",
  null
  
)

export default component.exports